import {
  EmailManagerGateway,
  DomainAction
} from "@/citizen/interactor/EmailManager";
import { RestConnection } from "./connection/RestConnection";
import { Email } from "@/entities/Email";
import { Domain } from "@/entities/Domain";

export class EmailManagerRestGateway implements EmailManagerGateway {
  public constructor(private connection: RestConnection) {}

  public insertEmail(email: string) {
    return this.connection.post("email", { email });
  }

  public removeEmail(email: string) {
    return this.connection.delete("email", { email });
  }

  public getDomainChallenge(domain: string, action: DomainAction) {
    return this.connection
      .get("domain/challenge", { domain, action })
      .then(data => {
        const domainObj = new Domain();
        domainObj.challenge = data.challenge;
        return domainObj;
      });
  }

  public sendPostmasterChallenge(domain: string, action: DomainAction) {
    return this.connection.get("domain/challenge/postmaster", {
      domain,
      action
    });
  }

  public sendHostmasterChallenge(domain: string, action: DomainAction) {
    return this.connection.get("domain/challenge/hostmaster", {
      domain,
      action
    });
  }

  public insertDomain(domain: string) {
    return this.connection.post("domain", { domain });
  }

  public removeDomain(domain: string) {
    return this.connection.delete("domain", { domain });
  }

  public verifySubject(subject: string, token: string) {
    return this.connection
      .put(subject + "/verification", { token })
      .then(data => data.action);
  }

  public checkEmails(emails: string[]): Promise<Email[]> {
    return this.connection.post("emails/check", { emails }).then(data =>
      data.emails.map((email: any) => {
        const emailObj = new Email();

        emailObj.plain = email;

        return emailObj;
      })
    );
  }
}
